var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAppearOfflineIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 159,
    viewBox: "0 0 159 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4996 158.999C123.406 158.999 158.999 123.406 158.999 79.4996C158.999 35.5932 123.406 0 79.4996 0C35.5932 0 0 35.5932 0 79.4996C0 123.406 35.5932 158.999 79.4996 158.999Z",
    fill: "url(#paint0_linear_284_950)",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.846 19.6633C144.089 33.6477 151.51 51.9614 151.51 72.0092C151.51 115.916 115.917 151.509 72.0101 151.509C51.9632 151.509 33.6487 144.088 19.6643 131.845C34.2367 148.488 55.6409 158.999 79.5004 158.999C123.407 158.999 159 123.406 159 79.4995C158.999 55.6399 148.489 34.2357 131.846 19.6633Z",
    fill: "url(#paint1_linear_284_950)",
    fillOpacity: 0.12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.811 21.4431C147.111 35.6552 155.255 54.7539 155.255 75.7544C155.255 119.661 119.662 155.254 75.7551 155.254C54.7546 155.254 35.6559 147.111 21.4438 133.811C35.951 149.312 56.5943 158.999 79.5003 158.999C123.407 158.999 159 123.406 159 79.4996C158.999 56.5935 149.312 35.9503 133.811 21.4431Z",
    fill: "url(#paint2_linear_284_950)",
    fillOpacity: 0.12
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2271 17.9999C45.4669 17.9999 18 45.4668 18 79.227C18 112.987 45.4669 140.454 79.2271 140.454C112.987 140.454 140.454 112.987 140.454 79.227C140.454 45.4668 112.987 17.9999 79.2271 17.9999ZM27.0707 79.227C27.0707 74.4174 27.7389 69.763 28.9635 65.337H45.6983C45.1388 69.7892 44.8339 74.4317 44.8339 79.227C44.8339 83.6148 45.0841 87.8782 45.5545 91.9822H28.6549C27.6243 87.8985 27.0707 83.6267 27.0707 79.227ZM53.9047 79.227C53.9047 74.4377 54.2447 69.7795 54.8642 65.337H74.6917V91.9822H54.7061C54.1848 87.8842 53.9047 83.6088 53.9047 79.227ZM83.7624 27.965C91.6152 31.0315 98.3221 41.8497 101.862 56.267H83.7624V27.965ZM74.6917 27.965V56.267H56.5929C60.1328 41.8497 66.8396 31.0315 74.6917 27.965ZM74.6917 101.054V130.49C66.6344 127.343 59.7838 116.035 56.3225 101.054H74.6917ZM83.7624 130.489V101.054H102.132C98.6711 116.035 91.8197 127.343 83.7624 130.489ZM83.7624 91.9822V65.337H103.591C104.21 69.7795 104.55 74.4377 104.55 79.227C104.55 83.6088 104.271 87.8842 103.749 91.9822H83.7624ZM112.757 65.337H129.491C130.715 69.7622 131.383 74.4167 131.383 79.227C131.383 83.6267 130.83 87.8985 129.8 91.9822H112.9C113.371 87.8782 113.621 83.614 113.621 79.227C113.621 74.4317 113.316 69.7892 112.757 65.337ZM126.044 56.2662H111.196C109.085 46.7199 105.687 38.4169 101.354 32.0105C112.078 37.0567 120.814 45.6465 126.044 56.2662ZM57.1008 32.0105C52.7669 38.4169 49.3693 46.7199 47.2585 56.2662H32.4106C37.6403 45.6465 46.3769 37.0567 57.1008 32.0105ZM31.875 101.054H47.0114C49.0989 111.079 52.5961 119.785 57.1008 126.443C45.9979 121.219 37.0313 112.194 31.875 101.054ZM101.353 126.443C105.858 119.784 109.355 111.078 111.443 101.054H126.579C121.424 112.194 112.456 121.219 101.353 126.443Z",
    fill: "#FFFEE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49122 80.9977C3.66729 80.9977 2.99316 80.3236 2.99316 79.4997C2.99316 79.4922 2.99316 79.4922 2.99316 79.4847C3.0014 78.6682 3.67478 78.0016 4.49122 78.0016C5.3159 78.0016 5.98179 78.6682 5.98928 79.4922V79.4997C5.98928 80.3236 5.32339 80.9977 4.49122 80.9977ZM4.73166 75.013C4.69421 75.013 4.64927 75.013 4.61182 75.013C3.78788 74.9456 3.17368 74.219 3.2336 73.3951C4.75413 54.2949 13.368 36.5579 27.4871 23.4424C41.6887 10.2595 60.1598 3.00139 79.4997 2.9939C80.3236 2.9939 80.9977 3.66802 80.9977 4.49195C80.9977 5.32337 80.3236 5.99001 79.4997 5.99001C41.4191 5.99001 9.23257 35.6965 6.22223 73.6273V73.6348C6.1623 74.4063 5.51065 75.013 4.73166 75.013Z",
    fill: "url(#paint3_linear_284_950)",
    fillOpacity: 0.12
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.696 123.013H53.303C51.4042 123.013 49.865 121.474 49.865 119.575V75.6303C49.865 73.7315 51.4042 72.1923 53.303 72.1923H105.697C107.596 72.1923 109.135 73.7315 109.135 75.6303V119.575C109.134 121.474 107.595 123.013 105.696 123.013Z",
    fill: "#FFD956"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.831 72.0001H101.779V111.893C101.779 113.791 100.24 115.331 98.3408 115.331H50V119.383C50 121.282 51.5393 122.821 53.438 122.821H105.832C107.731 122.821 109.27 121.282 109.27 119.383V75.4382C109.269 73.5394 107.73 72.0001 105.831 72.0001Z",
    fill: "#FFD956"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.628 72.1922H96.0336V57.0521C96.0336 47.9357 88.6167 40.5188 79.5002 40.5188C70.3838 40.5188 62.9669 47.9357 62.9669 57.0521V72.193H54.3711V57.0521C54.3711 43.1966 65.6432 31.9237 79.4995 31.9237C93.3558 31.9237 104.628 43.1958 104.628 57.0521V72.1922Z",
    fill: "#E6E7E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96 37.0001C99.4965 41.3175 101.597 46.8102 101.597 52.7859V67.9268H96.7475V71.6719H105.342V56.5318C105.343 48.652 101.693 41.6111 96 37.0001Z",
    fill: "#E6E7E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5944 107.388L83.3212 95.4563C85.1833 94.2182 86.4125 92.1022 86.4125 89.6985C86.4125 85.8807 83.3175 82.7865 79.4997 82.7865C75.6819 82.7865 72.5876 85.8815 72.5876 89.6985C72.5876 92.1029 73.8161 94.2182 75.6781 95.4563L71.4049 107.388C70.7877 109.112 72.0656 110.927 73.8969 110.927H85.1024C86.9338 110.927 88.2116 109.112 87.5944 107.388Z",
    fill: "#233332"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5944 107.388L83.3212 95.4563C85.1833 94.2182 86.4117 92.1021 86.4117 89.6978C86.4117 86.8163 84.6477 84.3489 82.1415 83.3108C82.4786 84.125 82.6666 85.0163 82.6666 85.9526C82.6666 88.357 81.4382 90.4723 79.5761 91.7112L83.8493 103.642C84.4665 105.367 83.1886 107.182 81.3573 107.182H71.4783L71.4049 107.388C70.7877 109.112 72.0656 110.927 73.8969 110.927H85.1024C86.9338 110.927 88.2116 109.112 87.5944 107.388Z",
    fill: "#233332"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_284_950",
    x1: -20.9915,
    y1: 24.1338,
    x2: 171.398,
    y2: 47.1323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4DE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9CFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_284_950",
    x1: 1.26885,
    y1: 40.8125,
    x2: 169.866,
    y2: 60.9667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4DE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9CFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_284_950",
    x1: 3.28335,
    y1: 42.3222,
    x2: 169.727,
    y2: 62.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4DE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9CFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_284_950",
    x1: -7.30519,
    y1: 14.8338,
    x2: 87.0807,
    y2: 26.1168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4DE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9CFB"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAppearOfflineIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/appear-offline-icon.ed6000fdbf06d6d65d6dffa4df9a3591.svg";